import { useEffect, useState } from "react";

/**
 * Subscribe to a CSS media query and re-render when it starts/stops
 * matching. SSR-safe: returns `false` until mounted in the browser.
 *
 * @param {string} query — a media query string, e.g. "(max-width: 640px)"
 * @returns {boolean} whether the query currently matches
 */
export function useMediaQuery(query) {
    const [matches, setMatches] = useState(
        () => typeof window !== "undefined" && window.matchMedia(query).matches,
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (e) => setMatches(e.matches);
        // Sync once in case the query changed between render and effect.
        setMatches(mql.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);

    return matches;
}

// Phones / narrow tablets get the mobile-native ledger; everything wider
// keeps the desktop table. Kept in one place so the breakpoint is shared.
export const MOBILE_QUERY = "(max-width: 640px)";

/** Convenience: true on phone-width viewports. */
export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
